// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
    padding: 10px 20px;
    background: #047da2;
    border-radius: 32px;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 1.2rem;
    color: #ffffff;
    cursor: pointer;
  }

.button:hover {
    background-color: #0592bd;
}

.button:disabled {
    background-color: #cccccc;
    color: #666666;
    cursor: not-allowed; 
}

.button:disabled:hover {
    background-color: #cccccc;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .button {
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/button/Button.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;AAEF;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".button {\n    padding: 10px 20px;\n    background: #047da2;\n    border-radius: 32px;\n    border: none;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 1.2rem;\n    color: #ffffff;\n    cursor: pointer;\n  }\n\n.button:hover {\n    background-color: #0592bd;\n}\n\n.button:disabled {\n    background-color: #cccccc;\n    color: #666666;\n    cursor: not-allowed; \n}\n\n.button:disabled:hover {\n    background-color: #cccccc;\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .button {\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
